import { useSearchParams } from 'react-router-dom'
import { Flex } from '@chakra-ui/react'

import '@/components/ambient/animations.css'
import { VerificationForm } from './components/verificationForm'

function VerificationPage() {
  const [searchParams] = useSearchParams()

  const email = searchParams.get('email') ?? ''
  const code = searchParams.get('code') ?? ''

  return (
    <Flex
      minH="100vh"
      minW="100vw"
      align="center"
      justify="center"
      bg="bg.primary"
      position="relative"
      overflow="hidden"
    >
      <VerificationForm email={email} code={code} />
    </Flex>
  )
}

export default VerificationPage
